import React, { useCallback, useMemo, useState } from 'react'
import { AppTitlePage } from '../../components/AppTitlePage'
import { AppFilterInput } from '../../components/AppInput/AppFilterInput'
import { AppTable } from '../../components/AppTable/AppTable'
import { AddTypeMismatchPopup } from './AddTypeMismatchPopup'
import { IPopup } from '../CategoriesPage/CategoriesPage'
import { AppBtnColor } from '../../components/btn/AppBtn'

import { useGetMismatchTypeListQuery } from 'core/api/TypeMismatchApi'
import { useParamsControl } from '../../utils/useParamsControl'
import {
  IMismatchTypeDto,
  IMismatchTypeRequest,
} from 'core/api/dto/TypeMismatchDto'
import { useDeleteTypeMismatch } from './hooks/useDeleteTypeMismatch'

import { IChooseItems } from 'core/api/dto/BuffetDishDto'
import { AppDeletePopup } from 'entities/AppDeletePopup/AppDeletePopup'

const headerData = [
  { title: 'Тип несоответствия', colWidth: '95%', sort: 'name' },
]

export const TypeMismatchPage = () => {
  const pageParams = useParamsControl<
    IMismatchTypeRequest,
    keyof IMismatchTypeRequest
  >({
    withPagination: true,
    whiteList: ['search', 'ordering'],
  })
  const {
    data: mismatchTypeList,
    isLoading: isLoadingGet,
    isFetching: isFetchingGet,
  } = useGetMismatchTypeListQuery(
    { ...pageParams, is_archived: false },
    { skip: !pageParams },
  )

  const [openCreatePopup, setOpenCreatePopup] = useState<IPopup>({
    active: false,
    id: null,
  })
  const [chooseItems, setChooseItems] = useState<IChooseItems | null>(null)
  const [tableData, setTableData] = useState<IMismatchTypeDto[]>([])

  const {
    deletePopup,
    closeDeletePopup,
    onDeletePopupHandler,
    onDeleteHandler,
  } = useDeleteTypeMismatch(chooseItems, setChooseItems)

  const openEditPopupHandler = useCallback(
    (id: number) => setOpenCreatePopup({ id, active: true }),
    [],
  )

  const closePopupHandler = useCallback(
    () => setOpenCreatePopup({ id: null, active: false }),
    [],
  )

  const tableActions = [
    {
      title: 'Удалить',
      ico: 'basket',
      onClick: onDeletePopupHandler,
    },
  ]

  const actions = useMemo(
    () => [
      {
        btnTitle: 'Создать тип несоответствия',
        btnIco: 'add',
        onClick: () =>
          setOpenCreatePopup((prevState) => ({ ...prevState, active: true })),
        color: AppBtnColor.whiteOutlineViolet,
      },
    ],
    [],
  )
  if (!mismatchTypeList) {
    return null
  }

  return (
    <React.Fragment>
      {openCreatePopup.active && (
        <AddTypeMismatchPopup
          closePopup={closePopupHandler}
          id={openCreatePopup.id}
        />
      )}
      {deletePopup && (
        <AppDeletePopup onClose={closeDeletePopup} onDelete={onDeleteHandler} />
      )}

      <div className="width-for-page-wrapper">
        <AppTitlePage title="Тип несоответствия" actions={actions} />
        <div className="col-7-width-from-1000">
          <div className="filter-block no-wrap mt-20">
            <AppFilterInput
              fullWidth
              searchParam={'search'}
              ico={'search'}
              label={'Поиск'}
              placeholder="Например: пережаренный"
            />
          </div>
          <AppTable
            data={mismatchTypeList}
            headerData={headerData}
            chooseItems={chooseItems}
            chooseMode
            setChooseItems={setChooseItems}
            setTableData={setTableData}
            tableDataSelectors={[
              {
                renderItem: (item) => (
                  <div
                    className={`table-link ${
                      item.isArchived ? 'delete-item' : ''
                    }`}
                    onClick={() => openEditPopupHandler(item.id)}
                  >
                    {item.name}
                  </div>
                ),
              },
            ]}
            chooseActions={tableActions}
            isLoading={isLoadingGet || isFetchingGet}
          />
        </div>
      </div>
    </React.Fragment>
  )
}
